import { atom } from "jotai";

export const postulantesAtom = atom([]);
export const abrirModalCarga = atom(false);
export const columnasAtom = atom([])